module.exports = __webpack_public_path__ + "static/media/segMieszane.7830abbb.png";